/**
 * Runner domain model
 * Represents a runner participating in a tracking event
 */
export class Runner {
  constructor(data) {
    this.firstName = data.firstName || ''
    this.lastName = data.lastName || ''
    this.number = data.number?.toString() || ''
    this.status = data.status || 'unknown'
    this.categoryName = data.categoryName || ''
    this.displayName = data.displayName || `${this.firstName} ${this.lastName}`.trim()
    this.startTime = data.startTime || null
  }

  get fullName() {
    return `${this.firstName} ${this.lastName}`.trim()
  }

  get isActive() {
    return this.status === 'active' || this.status === 'running'
  }

  static fromApiData(apiRunner) {
    const nameParts = (apiRunner.displayName || '').split(' ')
    return new Runner({
      firstName: nameParts[0] || '',
      lastName: nameParts.slice(1).join(' ') || '',
      number: apiRunner.number,
      status: apiRunner.status,
      categoryName: apiRunner.categoryName,
      displayName: apiRunner.displayName,
      startTime: apiRunner.startTime || null
    })
  }
}